import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";

// Pages
import HomePage from "./pages/HomePage";
import CategoryPage from "./pages/CategoryPage";
import PackageDetailPage from "./pages/PackageDetailPage";
import DashboardPage from "./pages/DashboardPage";
import CircuitePage from "./pages/CircuitePage";
import CityBreakPage from "./pages/CityBreakPage";
import TermsPage from "./pages/TermsPage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import DestinationPage from "./pages/DestinationPage";
import DestinationsIndexPage from "./pages/DestinationsIndexPage";
import PackageRedirect from "./pages/PackageRedirect";
import AIChatPage from "./pages/AIChatPage";
import OperatorDashboardPage from "./pages/OperatorDashboardPage";
import ShowcasePage from "./pages/ShowcasePage";
import ConcerteHubPage from "./pages/ConcerteHubPage";
import EvenimentePage from "./pages/EvenimentePage";

// Layout
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-navy">
        <BrowserRouter>
          <Navbar />
          <main className="min-h-screen">
            <Routes>
              <Route path="/" element={<HomePage />} />
              {/* Circuite Externe with continent/country hierarchy */}
              <Route path="/circuite" element={<CircuitePage />} />
              <Route path="/circuite/:continent" element={<CircuitePage />} />
              <Route path="/circuite/:continent/:country" element={<CircuitePage />} />
              {/* Circuite Romania */}
              <Route path="/circuite-romania" element={<CategoryPage category="Circuite Romania" />} />
              {/* City Break with country pages */}
              <Route path="/city-break" element={<CityBreakPage />} />
              <Route path="/city-break/:country" element={<CityBreakPage />} />
              {/* Concerte hub: 2 carduri (Concerte / Evenimente) */}
              <Route path="/concerte" element={<ConcerteHubPage />} />
              <Route path="/concerte/concerte" element={<CategoryPage category="Concerte" eventType="concert" />} />
              <Route path="/concerte/evenimente" element={<EvenimentePage />} />
              {/* Special sections */}
              <Route path="/last-minute" element={<CategoryPage special="last-minute" />} />
              <Route path="/early-booking" element={<CategoryPage special="early-booking" />} />
              <Route path="/populare" element={<CategoryPage special="populare" />} />
              <Route path="/ultimele-rezervari" element={<CategoryPage special="ultimele-rezervari" />} />
              {/* Legal pages */}
              <Route path="/termeni-si-conditii" element={<TermsPage />} />
              <Route path="/politica-de-cookies" element={<CookiePolicyPage />} />
              
              {/* SEO-friendly package URLs */}
              <Route path="/oferte/:destinationSlug/:slug" element={<PackageDetailPage useSeoUrl={true} />} />
              
              {/* Destination pages - SEO optimized */}
              <Route path="/destinatii" element={<DestinationsIndexPage />} />
              <Route path="/destinatii/:destinationSlug" element={<DestinationPage />} />
              
              {/* Legacy URL - redirect to SEO URL */}
              <Route path="/pachet/:id" element={<PackageRedirect />} />
              
              {/* Dashboard */}
              <Route path="/dashboard" element={<DashboardPage />} />
              
              {/* Operator Dashboard */}
              <Route path="/operator" element={<OperatorDashboardPage />} />
              
              {/* AI Chat Page */}
              <Route path="/ai-chat" element={<AIChatPage />} />
              
              {/* Showcase Page - for homepage cards with packages */}
              <Route path="/showcase/:cardId" element={<ShowcasePage />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: 'rgba(10, 37, 64, 0.95)',
              border: '1px solid rgba(212, 175, 55, 0.3)',
              color: '#fff',
            },
          }}
        />
      </div>
    </HelmetProvider>
  );
}

export default App;
